import React from 'react';

const SvgGraphs = props => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" {...props}>
    <g data-name="Group 114">
      <path
        data-name="Path 52"
        d="M3.89 13l1.18.3.9-1.4-1.7-.42A.78.78 0 103.88 13zm15.49.23l-3.89 3.5-4.57-3.54a.87.87 0 00-.29-.14l-.63-.16-.89 1.4 1 .24 5 3.84a.79.79 0 001 0l4.38-3.94a.78.78 0 00.08-1.11.79.79 0 00-1.12-.08zm-8.53-3.85l4.25 2.72a.79.79 0 001.08-.21l4.38-6.3a.79.79 0 00-.2-1.1.79.79 0 00-1.1.2l-3.94 5.68L11 7.63a.79.79 0 00-1.1.24L3.41 18.11a.79.79 0 001.34.89z"
        fill="#989898"
      />
    </g>
  </svg>
);

export default SvgGraphs;
